import React, { AnchorHTMLAttributes } from 'react';
import styled from 'astroturf/react';
import _Container from "LinkButton-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/design_system/LinkButton.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("a", null, {
  displayName: "Container",
  styles: _Container
});

export type LinkButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  color?: 'primary' | 'gray' | 'black';
  weight?: 'medium' | 'regular';
  disabled?: boolean;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  color = 'primary',
  weight = 'medium',
  disabled = false,
  href,
  children,
  onClick,
  ...props
}) => {
  return (
    <Container
      href={disabled ? undefined : href}
      color={color}
      weight={weight}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...props}
    >
      {children}
    </Container>
  );
};
